import { defineComponent } from 'vue';
import translator from '~/zf/frontend/common/mixins/translator';
import TreeNode from './TreeNode.vue';
import ApiService from '../../services/ApiService';
import AlertService from '~/zf/frontend/common/alert/AlertService';
export default defineComponent({
    name: 'AffectedComponent',
    components: { TreeNode },
    compatConfig: {
        MODE: 3,
    },
    mixins: [translator],
    props: {
        componentId: {
            type: Number,
            required: true,
        },
        componentType: {
            type: Number,
            required: true,
        },
        shouldCascade: {
            type: Boolean,
            required: true,
        },
        systemId: {
            type: Number,
            required: true,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            isLoading: false,
            componentTree: null,
        };
    },
    async mounted() {
        try {
            this.isLoading = true;
            this.componentTree = await ApiService.loadComponentTree(this.componentId, this.componentType, this.systemId, this.shouldCascade);
        }
        catch {
            AlertService.showError(this.tr('viiu.componentMuting.LOAD_MODAL_FAILED'));
        }
        finally {
            this.isLoading = false;
        }
    },
});
